const DotLoading = () => {
  return (
    <div className="dots-3"> </div>
  );
}

export default DotLoading;